import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import GuigotvAuth from './Auth/Guigotv'
import Home from './Auth/Home'
import VeroAuth from './Auth/Vero'

function Routers() {
  return (
    <Routes>
      <Route path='/auth'>
        <Route index element={<Home />} />
        <Route path='/auth/:usernameOfPartner' element={<GuigotvAuth />} />
        <Route path='/auth/verofamilia' element={<VeroAuth />} />
      </Route>
      <Route path='*' element={<Navigate replace to='/auth' />} />
    </Routes>
  )
}

export default Routers
